import React from "react";
import { Table, Modal, Typography, Tabs } from "antd";
import { roundDecimal, showAPC } from "../../utils";
import EmptySection from "../Layout/EmptySection";

const { Title } = Typography;

export default function ViewAllCases({ open, onClose, title = "All Case Nos.", width = 620, orderData }) {
  const data = orderData?.items || [];

  const bsrData = data.filter((item) => item?.cases_no);
  const foldingData = data.filter((item) => item?.folding_barcode);
  const greyData = data.filter((item) => item?.grey_pcsno);

  const getColumns = (type) => [
    {
      title: "Quality Name",
      dataIndex: "short_name",
      ellipsis: true,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Shade",
      dataIndex: "shade_name",
      ellipsis: true,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      render: (value, item) => value + showAPC(item.apc_no) || "-",
    },
    {
      title: "Quantity",
      key: "quantity",
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      ellipsis: true,
      render: (_, record) =>
        `${record.update_total_cases || record.cases || "0"} cases (
          ${roundDecimal(record.update_total_meter || record.quantity_meters || "0")}m)`,
    },
    {
      title: type === "bsr" ? "Case Nos." : type === "folding" ? "Barcodes" : "Piece Nos.",
      key: "ids",
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      render: (_, record) => {
        let ids = [];

        if (type === "bsr" && record.cases_no) {
          ids = record.cases_no.split(",");
        } else if (type === "folding" && record.folding_barcode) {
          ids = record.folding_barcode.split(",");
        } else if (type === "grey" && record.grey_pcsno) {
          ids = record.grey_pcsno.split(",");
        }

        return (
          <div>
            {ids
              .map((id) => id.trim())
              .filter(Boolean)
              .map((item, index) => (
                <div key={index}>{item}</div>
              ))}
          </div>
        );
      },
    },
  ];

  const tabItems = [];

  if (bsrData.length > 0) {
    tabItems.push({
      key: "in_stock",
      label: "In Stock",
      children: (
        <Table
          rowKey={(record) => `bsr_${record.order_item_id || Math.random()}`}
          columns={getColumns("bsr")}
          dataSource={bsrData}
          pagination={false}
          size="middle"
          className="mb-3"
          rootClassName="transparent-table"
        />
      ),
    });
  }

  if (foldingData.length > 0) {
    tabItems.push({
      key: "folding",
      label: "Folding",
      children: (
        <Table
          rowKey={(record) => `fold_${record.order_item_id || Math.random()}`}
          columns={getColumns("folding")}
          dataSource={foldingData}
          pagination={false}
          size="middle"
          className="mb-3"
          rootClassName="transparent-table"
        />
      ),
    });
  }

  if (greyData.length > 0) {
    tabItems.push({
      key: "grey",
      label: "Grey",
      children: (
        <Table
          rowKey={(record) => `grey_${record.order_item_id || Math.random()}`}
          columns={getColumns("grey")}
          dataSource={greyData}
          pagination={false}
          size="middle"
          className="mb-3"
          rootClassName="transparent-table"
        />
      ),
    });
  }

  return (
    <Modal className="form-css-2 custom-modal status-modal" open={open} footer={null} onCancel={onClose} centered width={width}>
      <div className="flex flex-col justify-between">
        <Title level={2} className="text-lg font-semibold text-black !mb-4 font-abhaya text-left">
          {title}
        </Title>

        {tabItems.length > 0 ? <Tabs defaultActiveKey={tabItems[0]?.key} items={tabItems} /> : <EmptySection bgClassname="!bg-transparent" />}
      </div>
    </Modal>
  );
}
